module.exports = __webpack_public_path__ + "static/media/4H.563ba2be.svg";